var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_4047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5701 20H4.90348C2.60598 20 0.736816 18.1309 0.736816 15.8334V8.10336C0.736816 6.71586 1.42348 5.42419 2.57348 4.64919L8.40598 0.712527C9.82182 -0.242473 11.6518 -0.242473 13.0676 0.712527L18.901 4.64919C20.0501 5.42419 20.7368 6.71503 20.7368 8.10336V15.8334C20.7368 18.1309 18.8676 20 16.5701 20Z",
    fill: "#637381"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_4047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.736816)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8b0cc63ba620ba946af8801512359879.svg";
export { ForwardRef as ReactComponent };